import './tompkins/style';
import FormStructure from './tompkins/form_structure';

export default FormStructure;